module.exports = __webpack_public_path__ + "img/spoonandforkcircle.74c4ce0b.png";